<div class="dropdown-wrapper">
  <ejs-dropdowntree
#organizationDropDownTree
#organizationTreeWrapper
id='organizationField'
[placeholder]='watermark'
 [showCheckBox]='showCheckBox'
  [mode]='mode'
 [treeSettings]='treeSettings'
  [fields]='treeFields'
  (change)="onOrganizationTreeChange($event)"
  cssClass="e-outline"
  [allowFiltering]="true"
  (dataBound)="onDataBound()"
  [filterType]="filterType"
  (filtering)="onFiltering($event)"
  (select)="onNodeSelect($event)"
  (input)="onInput($event)"
  [showClearButton]="false"
  [customTemplate]="customTemplate"
  [enabled]="!disabled && !loading"
  [itemTemplate]="itemTemplate">
</ejs-dropdowntree>
 
<ng-template #itemTemplate let-data>
  {{ data.text }} ({{ data.value.replace('org_', '') }})
</ng-template>
 
 
<!-- Custom Clear Button -->
<button
  *ngIf="getEnabledSelectedCount() > 0"
  mat-icon-button
  type="button"
  (click)="onCustomClear()"
  class="custom-clear-button"
>
  <mat-icon>clear</mat-icon>
</button>
<!-- </ng-container> -->
<div *ngIf="loading" class="spinner-overlay">
  <mat-spinner [diameter]="20"></mat-spinner>
</div>
<ng-template #customTemplate let-data>
  <div class="custom-template-wrapper">
    <ng-container *ngIf="getEnabledSelectedCount() > 0; else showPlaceholder">
      {{ getEnabledSelectedCount() }} item{{ getEnabledSelectedCount() > 1 ? 's' : '' }} selected
    </ng-container>
    <ng-template #showPlaceholder>
      <span class="location-placeholder">{{ watermark }}</span>
    </ng-template>
  </div>
</ng-template>
</div>